





































import Vue from 'vue';
import AutoCompleteInputOptions, {
  Option,
} from './AutoCompleteInputOptions.vue';
import OutlinedTextInput from '../OutlinedTextInput';
import Icon from '../Icon';

export default Vue.extend({
  components: {
    AutoCompleteInputOptions,
    OutlinedTextInput,
    Icon,
  },
  props: {
    value: {
      type: Object as Vue.PropType<Option>,
      required: true,
    },
    options: {
      type: Array as Vue.PropType<Option[]>,
      required: true,
    },
    fallbackOption: {
      type: Object as Vue.PropType<Option>,
      required: false,
    },
    iconTextInput: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    openDropDownAtFirstClick: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: this.value.value || '',
      dropDownEnabled: false,
      inputArray: this.options,
      selected: this.value,
      inputFocus: false,
      internalOptions: this.options,
    };
  },
  computed: {
    hasContent(): boolean {
      return this.input.length > (this.openDropDownAtFirstClick ? -1 : 0);
    },
  },
  watch: {
    value(newValue: Option): void {
      this.input = newValue.value;
      this.selected = newValue;
    },
    options(value) {
      this.internalOptions = value;
      this.filterOptions();
    },
  },
  methods: {
    filterOptions() {
      this.inputArray = this.internalOptions.filter((item) =>
        item.value.toLowerCase().includes(this.input.toLowerCase()),
      );

      if (this.fallbackOption && this.inputArray.length === 0)
        this.inputArray = [this.fallbackOption];
    },
    displayDropDown() {
      this.dropDownEnabled = this.hasContent;

      if (this.hasContent) this.filterOptions();
    },
    inputHandler() {
      this.$emit('input', this.input);
      this.displayDropDown();
    },
    closeDropDown(): void {
      this.dropDownEnabled = false;
    },
    selectOption(event: any): void {
      this.selected = event;
      this.$emit('selected', this.selected);
      this.closeDropDown();
    },
    isInputFocus() {
      this.input = this.selected.value || '';
      this.inputFocus = true;
    },
    isInputBlur() {
      this.input = this.selected.value || '';
      this.inputFocus = false;
    },
  },
});
